import {
  ChangeDetectionStrategy,
  Component,
  OnChanges,
  Input,
  ViewChild
} from '@angular/core';
import { Plan } from 'app/internal/plans/shared/models';
import { Property } from 'app/internal/property/shared/models';
import { FiscalYear, getNextFiscalYearDisplay } from 'app/internal/shared/models/fiscal-year';
import { DxPopoverComponent } from 'devextreme-angular/ui/popover';
@Component({
  selector: 'sp-steps-for-planning',
  templateUrl: './steps-for-planning.component.html',
  styleUrls: ['./steps-for-planning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class StepsForPlanningComponent implements OnChanges {

  @Input() plans: Plan[];
  @Input() property: Property;
  @Input() selectedFiscalYear: FiscalYear;
  @Input() disclosurePlanId: string;

  @ViewChild('finalizePopover', { static: false }) finalizePopover: DxPopoverComponent;

  lastCompletedStep = 1;
  showFinalizeStep = false;
  showDisclosureStep = false;
  finalizePopoverTarget: any;

  get nextFiscalYearDisplay(): string {
    return getNextFiscalYearDisplay(this.selectedFiscalYear);
  }

  /** Start date of the currently selected fiscal year (e.g. Feb 1, 2026 for 2026-27). */
  get selectedFiscalYearStartDate(): Date | null {
    if (!this.selectedFiscalYear) {
      return null;
    }
    const month = this.selectedFiscalYear.fiscalYearStartMonth - 1;
    return new Date(this.selectedFiscalYear.year, month, 1);
  }

  ngOnChanges() {
    this.lastCompletedStep = this.calculateCompletedSteps();
    this.showFinalizeStep = this.selectedFiscalYear.requireReconciliation;
    this.showDisclosureStep = this.property.isCalifornia || this.property.isWashington;
  }

  calculateCompletedSteps() {
    const hasRecommendedPlan = this.plans.find(p => p.isRecommended && !p.isDefaultRecommendedPlan) != null;
    const hasAdoptedPlan = this.plans.find(p => p.isAdopted) != null;
    const disclosureGenerated = this.disclosurePlanId != null;

    // step 5: advance to Planning with budget details
    if (hasAdoptedPlan) {
      return 5;
    }

    // step 4: generate disclosure (if CA or WA)
    if (this.showDisclosureStep && disclosureGenerated) {
      return 4;
    }

    // step 3: recommend a funding plan
    if (hasRecommendedPlan) {
      return 3;
    }

    // step 2: create and compare plans
    if (this.plans && this.plans.length > 1) {
      return 2;
    }

    // step 1: create components - done at planning year setup.
    return 1;
  }

  showFinalizePopover(event: MouseEvent) {
    if (!this.finalizePopover || !this.finalizePopover.instance) {
      return;
    }
    this.finalizePopoverTarget = event.currentTarget;
    this.finalizePopover.instance.show();
  }

  hideFinalizePopover() {
    if (!this.finalizePopover || !this.finalizePopover.instance) {
      return;
    }
    this.finalizePopover.instance.hide();
  }

  onFinalizePopoverHiding(e: any) {
    const isMouseInsidePopover = e.component.content().parentNode.matches(':hover');
    e.cancel = isMouseInsidePopover;
  }

  onFinalizePopoverContentReady(e: any) {
    (e.component.content() as HTMLElement).onmouseleave = function () {
      e.component.hide();
    };
  }
}
